var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObesityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68804 15.926C5.29786 16.15 6.02204 16.2974 6.86056 16.3681V18H4.68804V15.926ZM9.33799 18H11.5105V15.9099C10.8625 16.1353 10.1384 16.2847 9.33799 16.3581V18ZM7.98567 0C7.00274 0 6.20577 1.09329 6.20577 2.44176C6.20577 3.79026 7.00274 4.88355 7.98567 4.88355C8.96861 4.88355 9.76561 3.79026 9.76561 2.44176C9.76561 1.09325 8.96865 0 7.98567 0ZM16 10.9661C16 7.52952 13.5271 4.61225 10.1636 3.71995C10.0593 4.02165 9.91243 4.305 9.72788 4.5604C9.28046 5.17454 8.64543 5.52504 7.98607 5.52504C7.32671 5.52504 6.6902 5.17293 6.24427 4.5604C6.06107 4.30682 5.91498 4.02568 5.8109 3.72638C2.45952 4.62631 0 7.53794 0 10.9661H1.18159C1.1798 10.0845 1.37818 9.21525 1.76014 8.43105C1.68216 8.81889 1.64282 9.21427 1.64277 9.61074C1.64277 13.0151 2.75532 15.7736 8.0006 15.7736C13.5691 15.7736 14.3584 13.0131 14.3584 9.60874C14.3584 9.2128 14.3191 8.81796 14.241 8.43066C14.6226 9.21509 14.8206 10.0845 14.8184 10.9661H16Z",
    fill: "#FDFDFD",
    fillOpacity: 0.992157
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObesityIcon);
export default __webpack_public_path__ + "static/media/obesity-icon.d75dd1a451e9e778f76df322e788b99f.svg";
export { ForwardRef as ReactComponent };